import { render, staticRenderFns } from "./declaraciones_colaborador.vue?vue&type=template&id=f41167e6"
import script from "./declaraciones_colaborador.js?vue&type=script&lang=js&external"
export * from "./declaraciones_colaborador.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports